import axios from "axios";

import { SERVER_API_URL } from "@/constants";
const TIMEOUT = 1000000;
const onRequestSuccess = (config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  if (!config.url.includes("/auth/login")) {
    if (user == null || (user && user.expiDate < new Date())) {
      //debugger;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      let loc = window.location;
      loc.href = window.location.origin + "/Login";
    } else {
      user.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
      console.log("Axios user.expiDate:" + user.expiDate);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
    }
  }

  // if (!config.url.includes("/auth/authenticate")) {
  // 	if (user == null || (user && user.expiDate < new Date())) {
  // 		//debugger;
  // 		localStorage.removeItem("user");
  // 		localStorage.removeItem("token");
  // 		let loc = window.location;
  // 		loc.href = window.location.origin + "/Login";
  // 	} else {
  // 		user.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
  // 		console.log("Axios user.expiDate:" + user.expiDate);
  // 		localStorage.setItem("user", JSON.stringify(user));
  // 		localStorage.setItem("token", token);
  // 	}
  // }
  axios.defaults.headers = Object.assign({}, axios.defaults.headers, {
    "X-Username": user ? user.username : "",
    "X-Token-QLTP": localStorage.getItem("token"),
  });

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        // Handle 401 error here
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        let loc = window.location;
        loc.href = window.location.origin + "/Login";
      }
      return Promise.reject(error);
    }
  );

  /*  axios.defaults.headers = {
    "X-Username": user ? user.username : "",
  };*/
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated) => {
  const onResponseError = (err) => {
    // const status = err.status || err.response.status;
    // if (status === 401) {
    // 	console.log("status 401");
    // history.pushState({}, null, '/Login');
    // location.reload();
    // onUnauthenticated();
    // }
    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use((res) => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
